import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { legacyTarget } from "@/lib/legacyRedirects";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PublicLayout from "@/components/layout/PublicLayout";

import Home from "@/pages/public/Home";
import Edition2026 from "@/pages/public/Edition2026";
import Edition2028 from "@/pages/public/Edition2028";
import Programme from "@/pages/public/Programme";
import Intervenants from "@/pages/public/Intervenants";
import SpeakerDetail from "@/pages/public/SpeakerDetail";
import Articles from "@/pages/public/Articles";
import ArticleDetail from "@/pages/public/ArticleDetail";
import Partenaires from "@/pages/public/Partenaires";
import DevenirPartenaire from "@/pages/public/DevenirPartenaire";
import Archives from "@/pages/public/Archives";
import APropos from "@/pages/public/APropos";
import MentionsLegales from "@/pages/public/MentionsLegales";
import Inscription from "@/pages/public/Inscription";
import Billet from "@/pages/public/Billet";

import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import { EditionsAdmin, SpeakersAdmin, ConferencesAdmin, PartnersAdmin, ArticlesAdmin } from "@/pages/admin/ResourcePages";
import RegistrationsAdmin from "@/pages/admin/RegistrationsAdmin";
import CheckinAdmin from "@/pages/admin/CheckinAdmin";
import MediaAdmin from "@/pages/admin/MediaAdmin";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";
import UsersAdmin from "@/pages/admin/UsersAdmin";

const P = (C) => (
  <PublicLayout>
    <C />
  </PublicLayout>
);

function AppRouter() {
  const location = useLocation();
  // Emergent OAuth callback: process session_id before anything else
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  const legacy = legacyTarget(location.pathname);
  if (legacy) return <Navigate to={legacy} replace />;

  return (
    <Routes>
      <Route path="/" element={P(Home)} />
      <Route path="/edition-2026" element={P(Edition2026)} />
      <Route path="/edition-2028" element={P(Edition2028)} />
      <Route path="/programme" element={P(Programme)} />
      <Route path="/intervenants" element={P(Intervenants)} />
      <Route path="/intervenants/:slug" element={P(SpeakerDetail)} />
      <Route path="/blog" element={P(Articles)} />
      <Route path="/blog/:slug" element={P(ArticleDetail)} />
      <Route path="/partenaires" element={P(Partenaires)} />
      <Route path="/devenir-partenaire" element={P(DevenirPartenaire)} />
      <Route path="/archives" element={P(Archives)} />
      <Route path="/archives/:slug" element={P(Edition2026)} />
      <Route path="/a-propos" element={P(APropos)} />
      <Route path="/mentions-legales" element={P(MentionsLegales)} />
      <Route path="/inscription" element={P(Inscription)} />
      <Route path="/billet/:token" element={P(Billet)} />

      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="editions" element={<EditionsAdmin />} />
        <Route path="conferences" element={<ConferencesAdmin />} />
        <Route path="speakers" element={<SpeakersAdmin />} />
        <Route path="articles" element={<ArticlesAdmin />} />
        <Route path="partners" element={<PartnersAdmin />} />
        <Route path="registrations" element={<RegistrationsAdmin />} />
        <Route path="checkin" element={<CheckinAdmin />} />
        <Route path="media" element={<MediaAdmin />} />
        <Route path="settings" element={<SettingsAdmin />} />
        <Route path="users" element={<UsersAdmin />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
